import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {ChangePlanModalOpenOptions} from '@Panels/change-plan-modal-v2/change-plan-modal-v2.types';
import {setEntryStep} from '@Panels/change-plan-modal-v2/change-plan-modal-v2-reducer';

/**
 * Opens whichever change-plan dialog the feature flag selects. Lives beside the component rather than in it so
 * that file exports only its component, which is what lets react-refresh keep its boundary.
 */
export const openChangePlanModal = (preselectLevel?: number, preselectDuration?: number, options: ChangePlanModalOpenOptions = {}): void => {
  const modalId = window.PMW.modernChangePlanDialogEnabled ? MODALS_IDS.CHANGE_PLAN_MODAL_V2 : MODALS_IDS.CHANGE_PLAN_MODAL;
  // The box is sized from the current step and the panel is lazy-loaded, so the step has to be in place before the first frame.
  if (modalId === MODALS_IDS.CHANGE_PLAN_MODAL_V2 && options.initialStep !== undefined) {
    window.PMW.redux.store.dispatch(setEntryStep(options.initialStep));
  }
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId,
      panelProps: {preselectLevel, preselectDuration, ...options},
    })
  );
};
